<template>
  <div class="modal-window bds074">
    <header class="modal-header">
      <div class="tit"><em>*</em>{{ $i18nUtil.trans("title.ReqFeedBackAnswerer.001","피드백 답변자 지정") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt">{{ $i18nUtil.trans("entity.user.manager","상위 관리자") }}</div>
      <div class="info-txt smaller" v-if="tenantId !== '432'">
        {{ $i18nUtil.trans("message.ReqFeedbackAnswerer.001","* 상위관리자를 반드시 피드백 답변자로 지정해주세요.") }}
      </div>
      <div class="scroll-box">
        <ul class="scroll">
          <li
            v-for="(item, index) in answerTargetList"
            :key="'answerTarget' + index"
          >
            <input
              type="radio"
              name="answerTargetRadio"
              :id="'answerTargetRadio' + index"
              :value="item"
              v-model="checkedAnswerTarget"
              @click="checkSuperior(item)"
            /><label :for="'answerTargetRadio' + index" v-if="$i18nUtil.getLanguage() === 'ko'"
              >{{ item.ANSWERER_NAME }}({{ item.ANSWERER_DEPT_NAME }})</label
            >
              <label :for="'answerTargetRadio' + index" v-else
              >{{ item.ANSWERER_NAME_EN != null ? item.ANSWERER_NAME_EN : item.ANSWERER_NAME }}
                ({{ item.ANSWERER_DEPT_NAME_EN != null ? item.ANSWERER_DEPT_NAME_EN : item.ANSWERER_DEPT_NAME }})</label
            >
          </li>
        </ul>
      </div>

      <div v-if="modalInfo.isBoardMember" class="info-txt clear">
        {{ $i18nUtil.trans("entity.cogroupUser.groupKbn") }}
        <div class="fr">
          <input
            type="checkbox"
            name=""
            id="all"
            @click="selectedAllBoardMember"
            :checked="allcheckedBoardMember"
          /><label for="all">{{ $i18nUtil.trans("message.select.ALL","전체선택") }}</label>
        </div>
      </div>
      <div class="scroll-box" v-if="modalInfo.isBoardMember">
        <ul class="scroll">
          <div class="nodata" v-if="boardMemberList.length == 0">
            {{ $i18nUtil.trans("message.ReqFeedBackAnswerer.002","선택할 수 있는 멤버가 없습니다.") }}
          </div>
          <li
            v-else
            v-for="(item, index) in boardMemberList"
            :key="'boardMember' + index"
          >
            <input
              type="checkbox"
              name=""
              :id="'member' + index"
              :value="item"
              v-model="checkedBoardMember"
            /><label :for="'member' + index" v-if="$i18nUtil.getLanguage() === 'ko'"
              >{{ item.userName }}({{ item.deptName }})</label
            >
              <label :for="'member' + index" v-else
              >{{ item.userNameEn != null ? item.userNameEn : item.userName }}({{ item.deptNameEn != null ? item.deptNameEn : item.deptName }})</label
            >
          </li>
        </ul>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="registAnswerer">
        {{ $i18nUtil.trans("button.apply","적용") }}
      </button>
    </footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import EventBus from "@/js/eventbus/eventBus";
export default {
  props: {
    modalInfo: {
      type: Object,
    },
  },
  components: {
    Datepicker,
  },
  data() {
    return {
      tenantId: localStorage.getItem('tenantId'),
      answerTargetList: [],
      checkedAnswerTarget: {},
      prevCheckedAnswerTarget: {},
      boardMemberList: [],
      checkedBoardMember: [],
      allcheckedBoardMember: false,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  watch: {
    checkedBoardMember: function () {
      if (this.checkedBoardMember.length == this.boardMemberList.length) {
        this.allcheckedBoardMember = true;
      } else {
        this.allcheckedBoardMember = false;
      }
    },
  },
  created() {
    this.getAnswerTargetList();
  },
  mounted() {
    // console.log(this.modalInfo.userInfo);
    // this.boardMemberList = this.modalInfo.userList;
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    checkSuperior(item) {
      let selectedItem = item;
      if(this.tenantId === '432') {
        if(this.prevCheckedAnswerTarget != null && this.prevCheckedAnswerTarget.ANSWERER_ID != null && this.prevCheckedAnswerTarget.ANSWERER_ID === item.ANSWERER_ID) {
          selectedItem = null;
        }
      }
      this.checkedAnswerTarget = selectedItem;
      this.prevCheckedAnswerTarget = this.checkedAnswerTarget;
    },
    getAnswerTargetList() {
      let okrIds = "";
      this.modalInfo.paperKrLinkList.forEach((element, index, array) => {
        okrIds += element.okrId;
        if (index != array.length - 1) {
          okrIds += ",";
        }
      });
      let url = "/api/copaper/okr/getOkrSuperiorList";
      let param = {
        paperId: this.modalInfo.paperId,
        qrtCd: this.modalInfo.qrtCd,
        okrIds: okrIds,
      };
      let obj = this;
      this.showLoadingbar();
      axios
        .post(url, param)
        .then((res) => {
          this.hideLoadingbar();
          if (res.data.errorCode) {
            console.log("getPaperOkrList error", res.data.errorCode);
            // return;
          } else {
            // console.log(res.data.result);
            obj.answerTargetList = res.data.result;
            if(obj.modalInfo.answerer.superior == null && obj.modalInfo.changeAnswerer === 0) {
              obj.checkedAnswerTarget = res.data.result[0];
              obj.prevCheckedAnswerTarget = obj.checkedAnswerTarget;
            }else{
              obj.checkedAnswerTarget = obj.modalInfo.answerer.superior;
              obj.prevCheckedAnswerTarget = obj.checkedAnswerTarget;
            }
            
            obj.getBoardMemberList();
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    getBoardMemberList() {
      // console.log(this.answerTargetList.length);
      this.modalInfo.userList.forEach((user) => {
        // if(item.userId == this.modalInfo.userInfo.userId)
        let memberCheck = true;
        for (let i = 0; i < this.answerTargetList.length; i++) {
          let target = this.answerTargetList[i];
          if (user.userId == target.ANSWERER_ID) {
            memberCheck = false;
            break;
          }
        }
        if (memberCheck && user.userId != this.modalInfo.userId) {
          this.boardMemberList.push(user);
        }
      });

      let boardMem = this.modalInfo.answerer.boardMember;
      if(boardMem.length > 0) {
        for(var i=0; i<boardMem.length; i++) {
          this.checkedBoardMember.push(boardMem[i]);
        }
        if(this.boardMemberList.length > 0 && (boardMem.length === this.boardMemberList.length)) {
          this.allcheckedBoardMember = true;
        }
      }
    },
    selectedAllBoardMember() {
      this.checkedBoardMember = [];
      if (this.allcheckedBoardMember) {
        this.allcheckedBoardMember = false;
      } else {
        this.boardMemberList.forEach((value) => {
          this.checkedBoardMember.push(value);
        });
      }
    },
    registAnswerer() {
      if (this.checkedAnswerTarget == null) {
        if(this.tenantId === '432') {
          if(this.checkedBoardMember.length == 0) {
            this.toastInfo.message = this.$i18nUtil.trans("message.ReqFeedbackModal.015", "피드백 답변자는 1명 이상 선택해주세요.");
            this.showToast(this.toastInfo);
            return;
          }
        }else{
          this.toastInfo.message = this.$i18nUtil.trans("message.ReqFeedBackAnswerer.003","상위 관리자를 선택해주세요.");
          this.showToast(this.toastInfo);
          return;
        }
      }
      const payload = {
        superior: this.checkedAnswerTarget == null ? null : this.checkedAnswerTarget,
        boardMember: this.checkedBoardMember,
      };
      EventBus.$emit("registAnswerer", payload);
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/ReqFeedBackAnswerer.vue